import { render, staticRenderFns } from "./upLoginPwd.vue?vue&type=template&id=0fe0c1dc&scoped=true"
import script from "./upLoginPwd.vue?vue&type=script&lang=js"
export * from "./upLoginPwd.vue?vue&type=script&lang=js"
import style0 from "./upLoginPwd.vue?vue&type=style&index=0&id=0fe0c1dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0c1dc",
  null
  
)

export default component.exports